/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateGlobalToolVariationGroupSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateGlobalToolVariationGroupSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateGlobalToolVariationGroupSecurity = {
  option1?: CreateGlobalToolVariationGroupSecurityOption1 | undefined;
  option2?: CreateGlobalToolVariationGroupSecurityOption2 | undefined;
};

export type CreateGlobalToolVariationGroupRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type CreateGlobalToolVariationGroupSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateGlobalToolVariationGroupSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateGlobalToolVariationGroupSecurityOption1$Outbound,
    CreateGlobalToolVariationGroupSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createGlobalToolVariationGroupSecurityOption1ToJSON(
  createGlobalToolVariationGroupSecurityOption1:
    CreateGlobalToolVariationGroupSecurityOption1,
): string {
  return JSON.stringify(
    CreateGlobalToolVariationGroupSecurityOption1$outboundSchema.parse(
      createGlobalToolVariationGroupSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateGlobalToolVariationGroupSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateGlobalToolVariationGroupSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateGlobalToolVariationGroupSecurityOption2$Outbound,
    CreateGlobalToolVariationGroupSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createGlobalToolVariationGroupSecurityOption2ToJSON(
  createGlobalToolVariationGroupSecurityOption2:
    CreateGlobalToolVariationGroupSecurityOption2,
): string {
  return JSON.stringify(
    CreateGlobalToolVariationGroupSecurityOption2$outboundSchema.parse(
      createGlobalToolVariationGroupSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateGlobalToolVariationGroupSecurity$Outbound = {
  Option1?: CreateGlobalToolVariationGroupSecurityOption1$Outbound | undefined;
  Option2?: CreateGlobalToolVariationGroupSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateGlobalToolVariationGroupSecurity$outboundSchema:
  z.ZodMiniType<
    CreateGlobalToolVariationGroupSecurity$Outbound,
    CreateGlobalToolVariationGroupSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        CreateGlobalToolVariationGroupSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        CreateGlobalToolVariationGroupSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function createGlobalToolVariationGroupSecurityToJSON(
  createGlobalToolVariationGroupSecurity:
    CreateGlobalToolVariationGroupSecurity,
): string {
  return JSON.stringify(
    CreateGlobalToolVariationGroupSecurity$outboundSchema.parse(
      createGlobalToolVariationGroupSecurity,
    ),
  );
}

/** @internal */
export type CreateGlobalToolVariationGroupRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const CreateGlobalToolVariationGroupRequest$outboundSchema:
  z.ZodMiniType<
    CreateGlobalToolVariationGroupRequest$Outbound,
    CreateGlobalToolVariationGroupRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function createGlobalToolVariationGroupRequestToJSON(
  createGlobalToolVariationGroupRequest: CreateGlobalToolVariationGroupRequest,
): string {
  return JSON.stringify(
    CreateGlobalToolVariationGroupRequest$outboundSchema.parse(
      createGlobalToolVariationGroupRequest,
    ),
  );
}
